import { render, staticRenderFns } from "./DuplicateBooksTable.vue?vue&type=template&id=d4040808"
import script from "./DuplicateBooksTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./DuplicateBooksTable.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.7.3_lodash@4.17.21_prettier@2.8.8_vue-template-compiler@2.7.14_webpack@5.80.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports